export const DisplayTypesInRoleUsersConstant = {
    LIST: 1,
    ADD: 2,
    Edit: 3,
}
